export default {
  // 查询保证金列表
  selectYxcUserDepositByList: '/ygsjzs/yxcUserDeposit/selectYxcUserDepositByList',
  // 查询保证金详情
  selectYxcUserDepositByDepositId: '/ygsjzs/yxcUserDeposit/selectYxcUserDepositByDepositId',
  // 详情的流水导出
  exportYxcDepositTransaction: '/ygsjzs/yxcTransNew/exportYxcDepositTransaction',
  // 流水列表
  selectYxcTransNewByPage: '/ygsjzs/yxcTransNew/selectYxcTransNewByPage'
}
